<template>
  <v-card>
    <form-header
      :fullscreen="false"
      tour="reservation-split-form"
      :title='$lang("reservations.title_split")'
    />
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" xs="12" md="12">
            <!-- <v-date
              v-model="form.date"
              :label="$lang('reservations.fields.split_date')"
              :min="minSplitDate"
              :max="maxSplitDate"
              :error="!!validation.date"
              :error-messages="!!validation.date ? validation.date : []"
            ></v-date> -->
            <v-select
              :items="splitDates"
              v-model="form.date"
              :label="$lang('reservations.fields.split_date')"
              :error="!!validation.date"
              :error-messages="!!validation.date ? validation.date : []"
            />
            <c-properties-autocomplete
              v-model="form.property_id"
              @input="getUnits({ property_id: form.property_id })"
              :label="$lang('reservations.fields.property')"
              :error="!!validation.property_id"
              :error-messages="!!validation.property_id ? validation.property_id : []"
              :disabled="!form.date"
            />
            <c-units-autocomplete
              id="unit-selection"
              v-model="form.unit_id"
              :label="$lang('reservations.fields.unit')"
              :filters="searchUnitsFilters"
              :error="!!validation.unit_id"
              :error-messages="!!validation.unit_id ? validation.unit_id : []"
              :disabled="!form.property_id"
            />
          </v-col>
          <!-- <v-col cols="12" xs="12" md="12">
            <v-select
              v-model="form.room_type_id"
              prepend-icon="mdi-cash-multiple"
              :items="roomTypes.collection"
              item-value="id"
              item-text="name"
              :loading="roomTypes.loading"
              :label="$lang('reservations.fields.room_type')"
              :error="!!validation.room_type_id"
              :error-messages="!!validation.room_type_id ? validation.room_type_id : []"
            ></v-select>
          </v-col> -->
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit()" :loading="loading" :disabled="loading">{{ $lang("main.crud.save") }}</v-btn>
      <v-btn color="error" @click="cancel()">{{ $lang("main.crud.cancel") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  import MixpanelEvents from "@/constants/events";

  import formable from "@/mixins/formable";

  import {
    GET_ROOM_TYPES_COLLECTION,
  } from "@/store/room-types/actions";

  import {
    SPLIT_RESERVATIONS,
    SPLIT_RESERVATIONS_RESET,
  } from "@/store/reservations/actions";

  export default {
    name: "SplitForm",
    mixins: [
      formable
    ],
    props: {
      itemId: {
        type: Number,
        required: true
      },
      options: {
        type: Object,
        required: false,
        default() {
          return {};
        }
      }
    },
    data() {
      return {
        form: {
          date: null,
          room_type_id: null,
          unit_id: null,
          property_id: null,
        },
        searchUnitsFilters: {} 

      }
    },
    methods: {
      resetAction() {
        return SPLIT_RESERVATIONS_RESET;
      },
      submitAction() {
        return SPLIT_RESERVATIONS;
      },
      submitActionOptions() {
        return {
          id: this.itemId,
          ...this.form
        };
      },
      track() {
        this.$monitorService.track(MixpanelEvents.RESERVATION_SPLITTED, {
          accommodation_type: this.$constName('ConstPropertyTypes', this.options.reservation.property.type),
        });
      },
      getUnits(options) {
        if (!this.form.date) {
          return;
        }

        let filter = {
          order: 'asc',
          sortBy: 'name',
        };

        if (this.options.reservation.property_id) {
          filter.property_id = this.options.reservation.property_id;
        }
        if (options && options.property_id) {
          filter.property_id = options.property_id;
        }
        if (this.options.reservation.end_date && this.options.reservation.start_date) {
          filter.available = {
            except: this.itemId,
            end_date: this.options.reservation.end_date,
            start_date: this.form.date,
          };
        }

      this.searchUnitsFilters = filter;
      },
      getRoomTypes() {
        if (!this.form.unit_id) {
          return;
        }

        let unit = this.units.find((item) => {
          return item.id === this.form.unit_id
        });

        this.$store.dispatch(GET_ROOM_TYPES_COLLECTION, {
          unit_category_id: unit.unit_category_id,
          params: {
            _data: {
              selects: [
                'id',
                'name'
              ]
            }
          }
        })
      }
    },
    computed: {
      ...mapState({
        units: state => state.units.getCollectionRequest.collection,
        unitsRequest: state => state.units.getCollectionRequest,
        roomTypes: state => state.roomTypes.getCollectionRequest,
        loading: state => state.reservations.splitRequest.loading,
        validation: state => state.reservations.splitRequest.errors,
      }),
      // minSplitDate() {
      //   if (!this.options.reservation) {
      //     return null;
      //   }

      //   return this.options.reservation.start_date;
      // },
      // maxSplitDate() {
      //   if (!this.options.reservation) {
      //     return null;
      //   }

      //   return this.$moment(this.options.reservation.end_date).subtract(1, 'day').format('YYYY-MM-DD');
      // },
      splitDates() {
        let dates = [];

        let startDate = this.$moment(this.options.reservation.start_date);
        const endDate = this.$moment(this.options.reservation.end_date);

        while (startDate.isBefore(endDate)) {
          dates.push({
            value: startDate.format('YYYY-MM-DD'),
            text: `${startDate.locale(this.$locale()).format('ddd')} ${startDate.format('DD/MM/YYYY')}`,
          })

          startDate.add(1, 'day');
        }

        return dates;
      }
    },
  };
</script>
